/**
 * EnergyCertificateOfNeed — registry entry (Component only; completeness is
 * registered separately in `modules/completeness.ts` per the A-01 split).
 */

import type { PfConfigModule } from '../registry'
import { EnergyCertificateOfNeed } from './EnergyCertificateOfNeed.component'

export const energyCertificateOfNeedModule: PfConfigModule = {
  flowId: 'energy_certificate_of_need',
  Component: EnergyCertificateOfNeed,
}
